export const careers = [
    { value: "No idea yet", label_eng: "No idea yet", label_tch: "未有想法" },
    { value: "Doctor / Surgeon", label_eng: "Doctor / Surgeon", label_tch: "醫生 / 外科醫生" },
    { value: "Engineer", label_eng: "Engineer", label_tch: "工程師" },
    { value: "Software Developer / Programmer", label_eng: "Software Developer / Programmer", label_tch: "軟件開發員 / 程式員" },
    { value: "Data Scientist / AI Specialist", label_eng: "Data Scientist / AI Specialist", label_tch: "數據科學家 / 人工智能專家" },
    { value: "Lawyer / Legal Consultant", label_eng: "Lawyer / Legal Consultant", label_tch: "律師 / 法律顧問" },
    { value: "Teacher / Lecturer / Professor", label_eng: "Teacher / Lecturer / Professor", label_tch: "教師 / 講師 / 教授" },
    { value: "Architect", label_eng: "Architect", label_tch: "建築師" },
    { value: "Graphic Designer", label_eng: "Graphic Designer", label_tch: "平面設計師" },
    { value: "UX / UI Designer", label_eng: "UX / UI Designer", label_tch: "用戶體驗 / 用戶介面設計師" },
    { value: "Game Developer", label_eng: "Game Developer", label_tch: "遊戲開發員" },
    { value: "Psychologist / Therapist", label_eng: "Psychologist / Therapist", label_tch: "心理學家 / 治療師" },
    { value: "Marketing Specialist / Brand Strategist", label_eng: "Marketing Specialist / Brand Strategist", label_tch: "市場推廣專員 / 品牌策略師" },
    { value: "Content Creator / Influencer", label_eng: "Content Creator / Influencer", label_tch: "內容創作者 / 網紅" },
    { value: "Entrepreneur / Startup Founder", label_eng: "Entrepreneur / Startup Founder", label_tch: "創業家 / 初創公司創辦人" },
    { value: "Business Analyst / Consultant", label_eng: "Business Analyst / Consultant", label_tch: "業務分析師 / 顧問" },
    { value: "Financial Analyst / Investment Banker", label_eng: "Financial Analyst / Investment Banker", label_tch: "財務分析師 / 投資銀行家" },
    { value: "Pilot / Aviation Professional", label_eng: "Pilot / Aviation Professional", label_tch: "機師 / 航空專業人員" },
    { value: "Nurse / Healthcare Worker", label_eng: "Nurse / Healthcare Worker", label_tch: "護士 / 醫護人員" },
    { value: "Pharmacist", label_eng: "Pharmacist", label_tch: "藥劑師" },
    { value: "Research Scientist", label_eng: "Research Scientist", label_tch: "研究科學家" },
    { value: "Environmental Scientist / Sustainability Specialist", label_eng: "Environmental Scientist / Sustainability Specialist", label_tch: "環境科學家 / 可持續發展專家" },
    { value: "Journalist / Media Professional", label_eng: "Journalist / Media Professional", label_tch: "記者 / 傳媒專業人員" },
    { value: "Film Director / Producer", label_eng: "Film Director / Producer", label_tch: "電影導演 / 監製" },
    { value: "Actor / Performing Artist", label_eng: "Actor / Performing Artist", label_tch: "演員 / 表演藝術家" },
    { value: "Musician / Composer", label_eng: "Musician / Composer", label_tch: "音樂家 / 作曲家" },
    { value: "Social Worker / NGO Professional", label_eng: "Social Worker / NGO Professional", label_tch: "社工 / 非政府組織專業人員" },
    { value: "Public Relations Specialist", label_eng: "Public Relations Specialist", label_tch: "公關專員" },
    { value: "Cybersecurity Expert", label_eng: "Cybersecurity Expert", label_tch: "網絡安全專家" },
    { value: "Product Manager", label_eng: "Product Manager", label_tch: "產品經理" },
    { value: "Sports Professional / Athlete / Coach", label_eng: "Sports Professional / Athlete / Coach", label_tch: "運動專業人員 / 運動員 / 教練" },
    { value: "Other", label_eng: "Other", label_tch: "其他" },
];

export const disciplines = [
    { value: "Engineering", label_eng: "Engineering", label_tch: "工程學" },
    { value: "Arts & Humanities", label_eng: "Arts & Humanities", label_tch: "文學及人文學科" },
    { value: "Social Sciences", label_eng: "Social Sciences", label_tch: "社會科學" },
    { value: "Business", label_eng: "Business", label_tch: "商業" },
    { value: "Medicine", label_eng: "Medicine", label_tch: "醫學" },
    { value: "Design", label_eng: "Design", label_tch: "設計" },
    { value: "Law", label_eng: "Law", label_tch: "法律" },
    { value: "Education", label_eng: "Education", label_tch: "教育" },
    { value: "Science", label_eng: "Science", label_tch: "理學" },
    { value: "Architecture", label_eng: "Architecture", label_tch: "建築學" },
    { value: "Media Studies", label_eng: "Media Studies", label_tch: "傳媒研究" },
    { value: "Interdisciplinary", label_eng: "Interdisciplinary", label_tch: "跨學科" },
];

export const interests = [
    { value: "Problem Solving", label_eng: "Problem Solving", label_tch: "解決問題" },
    { value: "Designing", label_eng: "Designing", label_tch: "設計" },
    { value: "Traveling", label_eng: "Traveling", label_tch: "旅遊" },
    { value: "Music", label_eng: "Music", label_tch: "音樂" },
    { value: "Sports", label_eng: "Sports", label_tch: "運動" },
    { value: "Cooking", label_eng: "Cooking", label_tch: "烹飪" },
    { value: "Creative Arts", label_eng: "Creative Arts", label_tch: "創意藝術" },
    { value: "Helping People", label_eng: "Helping People", label_tch: "幫助他人" },
    { value: "Leadership", label_eng: "Leadership", label_tch: "領導才能" },
    { value: "Science", label_eng: "Science", label_tch: "科學" },
    { value: "Outdoor Activities", label_eng: "Outdoor Activities", label_tch: "戶外活動" },
    { value: "Writing", label_eng: "Writing", label_tch: "寫作" },
    { value: "Technology & Gadgets", label_eng: "Technology & Gadgets", label_tch: "科技與電子產品" },
    { value: "Public Speaking", label_eng: "Public Speaking", label_tch: "公開演講" },
    { value: "Performing Arts", label_eng: "Performing Arts", label_tch: "表演藝術" },
    { value: "Volunteering", label_eng: "Volunteering", label_tch: "義工服務" },
    { value: "Finance", label_eng: "Finance", label_tch: "金融" },
    { value: "Politics", label_eng: "Politics", label_tch: "政治" },
    { value: "Marketing", label_eng: "Marketing", label_tch: "市場推廣" },
    { value: "Gaming", label_eng: "Gaming", label_tch: "電子遊戲" },
];
export const years = [
    { value: "Form 1", label_eng: "Form 1", label_tch: "中一" },
    { value: "Form 2", label_eng: "Form 2", label_tch: "中二" },
    { value: "Form 3", label_eng: "Form 3", label_tch: "中三" },
    { value: "Form 4", label_eng: "Form 4", label_tch: "中四" },
    { value: "Form 5", label_eng: "Form 5", label_tch: "中五" },
    { value: "Form 6", label_eng: "Form 6", label_tch: "中六" }
];

export const mbti = [
    {
        code: "INTJ",
        value: "INTJ - Architect (Imaginative and strategic thinkers, with a plan for everything)",
        label_eng: "INTJ - Architect (Imaginative and strategic thinkers, with a plan for everything)",
        label_tch: "INTJ - 建築師型 (富有想像力和策略性的思想家，凡事都有計劃)",
    },
    {
        code: "INTP",
        value: "INTP - Logician (Innovative inventors with an unquenchable thirst for knowledge)",
        label_eng: "INTP - Logician (Innovative inventors with an unquenchable thirst for knowledge)",
        label_tch: "INTP - 邏輯學家型 (富有創新精神的發明家，對知識有無窮的渴望)",
    },
    {
        code: "ENTJ",
        value: "ENTJ - Commander (Bold, imaginative, and strong-willed leaders, always finding a way or making one)",
        label_eng: "ENTJ - Commander (Bold, imaginative, and strong-willed leaders, always finding a way or making one)",
        label_tch: "ENTJ - 指揮官型 (大膽、富有想像力和意志堅強的領導者，總能找到或創造出路)",
    },
    {
        code: "ENTP",
        value: "ENTP - Debater (Curious and flexible thinkers who cannot resist an intellectual challenge)",
        label_eng: "ENTP - Debater (Curious and flexible thinkers who cannot resist an intellectual challenge)",
        label_tch: "ENTP - 辯論家型 (好奇且靈活的思想家，無法抗拒智力挑戰)",
    },
    {
        code: "INFJ",
        value: "INFJ - Advocate (Quiet visionaries, often serving as inspiring and tireless idealists)",
        label_eng: "INFJ - Advocate (Quiet visionaries, often serving as inspiring and tireless idealists)",
        label_tch: "INFJ - 提倡者型 (安靜的夢想家，經常成為鼓舞人心和不知疲倦的理想主義者)",
    },
    {
        code: "INFP",
        value: "INFP - Mediator (Poetic, kind, and altruistic people, always eager to help a good cause)",
        label_eng: "INFP - Mediator (Poetic, kind, and altruistic people, always eager to help a good cause)",
        label_tch: "INFP - 調停者型 (詩意、善良和利他的人，總是渴望幫助有意義的事業)",
    },
    {
        code: "ENFJ",
        value: "ENFJ - Protagonist (Inspiring optimists, readily taking action to do what they feel is right)",
        label_eng: "ENFJ - Protagonist (Inspiring optimists, readily taking action to do what they feel is right)",
        label_tch: "ENFJ - 主人公型 (鼓舞人心的樂觀主義者，樂於採取行動做他們認為正確的事)",
    },
    {
        code: "ENFP",
        value: "ENFP - Campaigner (Enthusiastic, creative, and sociable free spirits, who can always find a reason to smile)",
        label_eng: "ENFP - Campaigner (Enthusiastic, creative, and sociable free spirits, who can always find a reason to smile)",
        label_tch: "ENFP - 競選者型 (熱情、有創造力和善於交際的自由精神，總能找到微笑的理由)",
    },
    {
        code: "ISTJ",
        value: "ISTJ - Logistician (Practical and fact-minded individuals, whose reliability cannot be doubted)",
        label_eng: "ISTJ - Logistician (Practical and fact-minded individuals, whose reliability cannot be doubted)",
        label_tch: "ISTJ - 物流師型 (務實且注重事實的人，其可靠性毋庸置疑)",
    },
    {
        code: "ISFJ",
        value: "ISFJ - Defender (Very dedicated and warm protectors, always ready to defend their loved ones)",
        label_eng: "ISFJ - Defender (Very dedicated and warm protectors, always ready to defend their loved ones)",
        label_tch: "ISFJ - 守衛者型 (非常盡責和溫暖的保護者，隨時準備保護親愛的人)",
    },
    {
        code: "ESTJ",
        value: "ESTJ - Executive (Excellent organizers, unsurpassed at managing things - or people)",
        label_eng: "ESTJ - Executive (Excellent organizers, unsurpassed at managing things - or people)",
        label_tch: "ESTJ - 總經理型 (出色的組織者，在管理事物或人方面無人能及)",
    },
    {
        code: "ESFJ",
        value: "ESFJ - Consul (Very caring, social, community-minded people who are always eager to help)",
        label_eng: "ESFJ - Consul (Very caring, social, community-minded people who are always eager to help)",
        label_tch: "ESFJ - 執政官型 (非常關懷、善於社交、有社區意識的人，總是渴望幫助他人)",
    },
    {
        code: "ISTP",
        value: "ISTP - Virtuoso (Innovative and practical experimenters, masters of all kinds of tools)",
        label_eng: "ISTP - Virtuoso (Innovative and practical experimenters, masters of all kinds of tools)",
        label_tch: "ISTP - 鑒賞家型 (富有創新和實踐精神的實驗者，精通各種工具)",
    },
    {
        code: "ISFP",
        value: "ISFP - Adventurer (Flexible and charming, always ready to explore and experience something new)",
        label_eng: "ISFP - Adventurer (Flexible and charming, always ready to explore and experience something new)",
        label_tch: "ISFP - 探險家型 (靈活且迷人，隨時準備探索和體驗新事物)",
    },
    {
        code: "ESTP",
        value: "ESTP - Entrepreneur (Savvy, energetic, and very perceptive people who truly enjoy living on the edge)",
        label_eng: "ESTP - Entrepreneur (Savvy, energetic, and very perceptive people who truly enjoy living on the edge)",
        label_tch: "ESTP - 企業家型 (精明、充滿活力和洞察力的人，真正享受刺激的生活)",
    },
    {
        code: "ESFP",
        value: "ESFP - Entertainer (Spontaneous, energetic, and enthusiastic people - life is never boring around them)",
        label_eng: "ESFP - Entertainer (Spontaneous, energetic, and enthusiastic people - life is never boring around them)",
        label_tch: "ESFP - 表演者型 (自發、充滿活力和熱情的人 - 他們身邊的生活永不無聊)",
    },
    {
        code: "Other",
        value: "Other",
        label_eng: "Prefer not to say / Not sure",
        label_tch: "不願透露 / 不確定",
    },
];
export const categoryAGrades = ["5**", "5*", "5", "4", "3", "2", "1", "U", "N/A"];
export const csdGrades = ["Attained", "Unattained", "N/A"];
export const categoryBGrades = ["Dist II", "Dist I", "Att", "Unatt", "N/A"];
export const categoryCGrades = ["C2", "C1", "B2", "B1", "A2", "N/A"]; // for french, german, spanish
export const koreanGrades = ["Grade 6", "Grade 5", "Grade 4", "Grade 3", "N/A"]
export const japaneseGrades = ["N1", "N2", "N3", "N/A"] 
export const urduGrades = ["A++", "A+", "A", "B++", "B+", "B", "C", "D", "E", "N/A"]